import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./tag.html";
class AceTag extends LightningElement {
  constructor(...args) {
    super(...args);
    this.disabled = false;
    this.text = null;
    this.ariaLabel = null;
    this.ariaLive = null;
    this.href = null;
  }
  get analyticsSourceProps() {
    return {
      disabled: this.disabled,
      callToAction: {
        label: this.text,
        url: this.href
      }
    };
  }
  handleAnalytics(event) {
    event.detail.tag = this.analyticsSourceProps;
  }
  handleClick(event) {
    if (this.disabled) {
      event.stopPropagation();
    }
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(AceTag, {
  publicProps: {
    disabled: {
      config: 0
    },
    text: {
      config: 0
    },
    ariaLabel: {
      config: 0
    },
    ariaLive: {
      config: 0
    },
    href: {
      config: 0
    }
  }
});
const __lwc_component_class_internal = _registerComponent(AceTag, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;